module.exports = __webpack_public_path__ + "img/kjcx.fc6e7086.png";